// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"TabHeader_text-gradient__28REp","tab_header":"TabHeader_tab_header__x8Chw","title":"TabHeader_title__3e5Qu","counter":"TabHeader_counter__1fQzJ"};